import { z } from "zod";
import {
  dataStateSchema,
  freshnessSchema,
  qualitySchema,
  reconciliationSchema,
} from "./governance";
import {
  isoDateTimeSchema,
  jsonValueSchema,
  opaqueIdSchema,
  permissionKeySchema,
  versionSchema,
} from "./primitives";

export function dashboardWidgetSchema<T extends z.ZodTypeAny>(payloadSchema: T) {
  return z
    .object({
      widgetId: opaqueIdSchema,
      schemaVersion: versionSchema,
      definitionVersion: versionSchema.optional(),
      asOf: isoDateTimeSchema,
      dataState: dataStateSchema,
      authorityClass: z.string().trim().min(1).max(100).optional(),
      sourceSummary: z.string().trim().min(1).max(1_000),
      freshness: freshnessSchema.default("UNKNOWN"),
      quality: qualitySchema,
      reconciliation: reconciliationSchema.default("UNKNOWN"),
      permissions: z.array(permissionKeySchema).max(100).default([]),
      drillThroughToken: z.string().trim().min(1).max(2_048).optional(),
      payload: payloadSchema,
    })
    .strict();
}

export const dashboardWidgetJsonSchema = dashboardWidgetSchema(jsonValueSchema);

export const dashboardWarningSchema = z
  .object({
    code: z
      .string()
      .trim()
      .regex(/^[A-Z][A-Z0-9_]*$/)
      .max(100),
    message: z.string().trim().min(1).max(1_000),
    widgetIds: z.array(opaqueIdSchema).max(100).optional(),
  })
  .strict();

export const dashboardResponseSchema = z
  .object({
    view: z.string().trim().min(1).max(100),
    schemaVersion: versionSchema,
    tenantId: opaqueIdSchema,
    generatedAt: isoDateTimeSchema,
    dataAsOf: isoDateTimeSchema,
    widgets: z.array(dashboardWidgetJsonSchema).max(500),
    warnings: z.array(dashboardWarningSchema).max(100).default([]),
  })
  .strict();

export type DashboardWidget<T> = Omit<z.infer<typeof dashboardWidgetJsonSchema>, "payload"> & {
  payload: T;
};
export type DashboardResponse = z.infer<typeof dashboardResponseSchema>;

